var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0002 -6.10352e-05C11.3808 -6.10352e-05 11.7284 0.216011 11.8969 0.557315L14.7544 6.34641L21.1448 7.28045C21.5213 7.33549 21.834 7.5995 21.9514 7.96151C22.0688 8.32351 21.9705 8.72077 21.6979 8.9863L17.0747 13.4893L18.1658 19.8509C18.2301 20.2261 18.0759 20.6053 17.7679 20.829C17.4599 21.0527 17.0516 21.0822 16.7147 20.905L11.0002 17.8998L5.2856 20.905C4.94869 21.0822 4.5404 21.0527 4.23242 20.829C3.92444 20.6053 3.77019 20.2261 3.83454 19.8509L4.92563 13.4893L0.302418 8.9863C0.0298003 8.72077 -0.0684725 8.32351 0.0489051 7.96151C0.166283 7.5995 0.478963 7.33549 0.855523 7.28045L7.24589 6.34641L10.1034 0.557315C10.2719 0.216011 10.6195 -6.10352e-05 11.0002 -6.10352e-05ZM11.0002 3.25919L8.80686 7.70256C8.66132 7.99741 8.38013 8.20187 8.05478 8.24943L3.14856 8.96654L6.69788 12.4236C6.93376 12.6533 7.04142 12.9845 6.98576 13.309L6.14833 18.1916L10.5347 15.8849C10.8261 15.7316 11.1742 15.7316 11.4656 15.8849L15.852 18.1916L15.0145 13.309C14.9589 12.9845 15.0665 12.6533 15.3024 12.4236L18.8517 8.96654L13.9455 8.24943C13.6202 8.20187 13.339 7.99741 13.1934 7.70256L11.0002 3.25919Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.6880340a.svg";
export { ForwardRef as ReactComponent };